import EqualHeightElementCollection from "@/ts/base/Components/EqualHeightElementCollection";

class EqualHeightPostCardCollection extends EqualHeightElementCollection {
	getSelector() {
		return ".post-card.equal-height";
	}

	getComponents(): NodeListOf<HTMLElement>[] {
		const selector = this.getSelector();
		return [
			(this.container || document).querySelectorAll(selector +" .post-thumbnail"),
			(this.container || document).querySelectorAll(selector +" .read-more-zone"),
			(this.container || document).querySelectorAll(selector +" .post-header"),
			(this.container || document).querySelectorAll(selector +" .post-excerpt")
		];
	}
}

export default EqualHeightPostCardCollection;
